import React from "react";
import { Card, Button, Row, Col, Container, Figure } from "react-bootstrap";
import {
  FaPinterest,
  FaInstagram,
  FaLinkedin,
  FaTimes,
  FaFacebook,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { sponsors } from "../components/shared/constraints";

const About = () => {
  return (
    <section className="sponser-sec inner-wrapper">
      <Container>
        <div class="common-heading text-center mb-4">
          <h2>Meet Our Development Team</h2>
        </div>
        <Row>
          {sponsors.map((sponsor, index) => (
            <Col md={4} className="mb-5" key={index}>
              <Card className="sponser-cards speaker-box-layout2 position-relative">
                <Figure>
                  <Card.Img variant="top" src={sponsor.image} alt="Profile" />
                </Figure>
                <Card.Body className="content-box text-start">
                  <Card.Title style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {sponsor.name}
                  </Card.Title>
                  <Card.Text
                    style={{ color: "gray", fontSize: "14px" }}
                    className="mb-0"
                  >
                    {sponsor.role}
                  </Card.Text>
                  <Card.Text
                    style={{ color: "gray", fontSize: "14px" }}
                    className="font-bold text-black"
                  >
                    {sponsor.experience}
                  </Card.Text>

                  <div className="speaker-social">
                    <ul className="list-unstyled">
                      {/* <li>
                        <Link to={sponsor.socialLinks.pinterest} variant="link">
                          <FaPinterest size={20} />
                        </Link>
                      </li> */}
                      <li>
                        <Link to={sponsor.socialLinks.instagram} variant="link">
                          <FaInstagram size={20} />
                        </Link>
                      </li>
                      <li>
                        <Link to={sponsor.socialLinks.linkedin} variant="link">
                          <FaLinkedin size={20} />
                        </Link>
                      </li>
                      {/* <li>
                        <Link to={sponsor.socialLinks.close} variant="link">
                          <FaTimes size={20} />
                        </Link>
                      </li> */}
                      <li>
                        <Link to={sponsor.socialLinks.facebook} variant="link">
                          <FaFacebook size={20} />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default About;
